"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { id: "spectator-home" };
const _hoisted_2 = { class: "player_home_block nofloat" };
const _hoisted_3 = {
    key: 3,
    class: "player_home_block--milestones-and-awards"
};
const _hoisted_4 = {
    key: 4,
    class: "player_home_block",
    ref: "colonies",
    id: "shortkey-colonies"
};
const _hoisted_5 = { class: "colonies-fleets-cont" };
const _hoisted_6 = { class: "player_home_colony_cont" };
const _hoisted_7 = { key: 0 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_sidebar = (0, vue_1.resolveComponent)("sidebar");
    const _component_log_panel = (0, vue_1.resolveComponent)("log-panel");
    const _component_players_overview = (0, vue_1.resolveComponent)("players-overview");
    const _component_board = (0, vue_1.resolveComponent)("board");
    const _component_turmoil = (0, vue_1.resolveComponent)("turmoil");
    const _component_MoonBoard = (0, vue_1.resolveComponent)("MoonBoard");
    const _component_PlanetaryTracks = (0, vue_1.resolveComponent)("PlanetaryTracks");
    const _component_Milestone = (0, vue_1.resolveComponent)("Milestone");
    const _component_Awards = (0, vue_1.resolveComponent)("Awards");
    const _component_dynamic_title = (0, vue_1.resolveComponent)("dynamic-title");
    const _component_colony = (0, vue_1.resolveComponent)("colony");
    const _component_waiting_for = (0, vue_1.resolveComponent)("waiting-for");
    const _directive_trim_whitespace = (0, vue_1.resolveDirective)("trim-whitespace");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_sidebar, {
            acting_player: false,
            player_color: _ctx.spectator.color,
            generation: _ctx.game.generation,
            coloniesCount: _ctx.game.colonies.length,
            temperature: _ctx.game.temperature,
            oxygen: _ctx.game.oxygenLevel,
            oceans: _ctx.game.oceans,
            venus: _ctx.game.venusScaleLevel,
            turmoil: _ctx.game.turmoil,
            moonData: _ctx.game.moon,
            gameOptions: _ctx.game.gameOptions,
            playerNumber: _ctx.spectator.players.length,
            lastSoloGeneration: _ctx.game.lastSoloGeneration,
            deckSize: _ctx.game.deckSize,
            discardPileSize: _ctx.game.discardPileSize
        }, null, 8, ["player_color", "generation", "coloniesCount", "temperature", "oxygen", "oceans", "venus", "turmoil", "moonData", "gameOptions", "playerNumber", "lastSoloGeneration", "deckSize", "discardPileSize"]), [
            [_directive_trim_whitespace]
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (_ctx.spectator.id !== undefined)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_log_panel, {
                    key: 0,
                    viewModel: _ctx.spectator,
                    color: _ctx.spectator.color,
                    step: _ctx.game.step
                }, null, 8, ["viewModel", "color", "step"]))
                : (0, vue_1.createCommentVNode)("", true)
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_players_overview, {
            class: "player_home_block player_home_block--players nofloat",
            playerView: _ctx.spectator,
            id: "shortkey-playersoverview"
        }, null, 8, ["playerView"]), [
            [_directive_trim_whitespace]
        ]),
        _cache[2] || (_cache[2] = (0, vue_1.createElementVNode)("a", {
            name: "board",
            class: "player_home_anchor"
        }, null, -1)),
        (0, vue_1.createVNode)(_component_board, {
            spaces: _ctx.game.spaces,
            expansions: _ctx.game.gameOptions.expansions,
            venusScaleLevel: _ctx.game.venusScaleLevel,
            boardName: _ctx.game.gameOptions.boardName,
            oceans_count: _ctx.game.oceans,
            oxygen_level: _ctx.game.oxygenLevel,
            temperature: _ctx.game.temperature,
            altVenusBoard: _ctx.game.gameOptions.altVenusBoard,
            aresData: _ctx.game.aresData,
            tileView: _ctx.tileView,
            onToggleTileView: _cache[0] || (_cache[0] = ($event) => (_ctx.cycleTileView())),
            id: "shortkey-board"
        }, null, 8, ["spaces", "expansions", "venusScaleLevel", "boardName", "oceans_count", "oxygen_level", "temperature", "altVenusBoard", "aresData", "tileView"]),
        (_ctx.game.turmoil)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_turmoil, {
                key: 0,
                turmoil: _ctx.game.turmoil
            }, null, 8, ["turmoil"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.game.moon !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_MoonBoard, {
                key: 1,
                model: _ctx.game.moon,
                tileView: _ctx.tileView
            }, null, 8, ["model", "tileView"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.game.gameOptions.expansions.pathfinders)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_PlanetaryTracks, {
                key: 2,
                tracks: _ctx.game.pathfinders,
                gameOptions: _ctx.game.gameOptions
            }, null, 8, ["tracks", "gameOptions"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.spectator.players.length > 1)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                (0, vue_1.createVNode)(_component_Milestone, {
                    milestones: _ctx.game.milestones
                }, null, 8, ["milestones"]),
                (0, vue_1.createVNode)(_component_Awards, {
                    awards: _ctx.game.awards,
                    "show-scores": ""
                }, null, 8, ["awards"])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.spectator.game.colonies.length > 0)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                _cache[1] || (_cache[1] = (0, vue_1.createElementVNode)("a", {
                    name: "colonies",
                    class: "player_home_anchor"
                }, null, -1)),
                (0, vue_1.createVNode)(_component_dynamic_title, {
                    title: "Colonies",
                    color: _ctx.spectator.color
                }, null, 8, ["color"]),
                (0, vue_1.createElementVNode)("div", _hoisted_5, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.spectator.players, (player) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            class: "colonies-player-fleets",
                            key: player.color
                        }, [
                            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.range(Math.max(0, player.fleetSize - player.tradesThisGeneration)), (idx) => {
                                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    class: (0, vue_1.normalizeClass)('colonies-fleet colonies-fleet-' + player.color),
                                    key: idx
                                }, null, 2));
                            }), 128))
                        ]));
                    }), 128))
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_6, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.spectator.game.colonies, (colony) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            class: "player_home_colony",
                            key: colony.name
                        }, [
                            (0, vue_1.createVNode)(_component_colony, {
                                colony: colony,
                                active: colony.isActive
                            }, null, 8, ["colony", "active"])
                        ]));
                    }), 128))
                ]),
                (_ctx.game.gameOptions.expansions.pathfinders)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7, [
                        (0, vue_1.createVNode)(_component_PlanetaryTracks, {
                            tracks: _ctx.game.pathfinders,
                            gameOptions: _ctx.game.gameOptions
                        }, null, 8, ["tracks", "gameOptions"])
                    ]))
                    : (0, vue_1.createCommentVNode)("", true)
            ], 512))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.game.phase !== 'end')
            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_waiting_for, {
                key: 5,
                players: _ctx.spectator.players,
                playerView: _ctx.spectator,
                settings: _ctx.settings,
                waitingfor: undefined
            }, null, 8, ["players", "playerView", "settings"])), [
                [vue_1.vShow, false]
            ])
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
